import { useTranslation } from 'react-i18next';

import { useMutation } from '@tanstack/react-query';

import { ApiError } from '../../../../Shared/interfaces/ApiError';
import useApiClient from '../../../../Shared/services/api';
import { downloadFile } from '../../../../Shared/utils/fileDownload';
import { downloadBookingSheet } from '../services/service';
import { DownloadBookingFilters } from '../utils/downloadFilters';
import { SHARED_CONSTANTS } from '../../../../Shared/constants/commonConstants';

export const useDownloadMutation = (setSuccessMessage: React.Dispatch<React.SetStateAction<string | null>>) => {
    const { t } = useTranslation();
    const api = useApiClient();

    return useMutation<
        Blob,
        ApiError,
        { artEventId: string; bookingStatus: string } & DownloadBookingFilters
    >({
        mutationFn: ({ artEventId, bookingStatus, ...filters }) =>
            downloadBookingSheet(api, artEventId, bookingStatus, filters),
        onSuccess: (response, { artEventId }) => {
            downloadFile(response, `${artEventId}-ad-slots-bookingSheet`);
            setSuccessMessage(t('download-success-message'));

            // Auto-clear success message
            setTimeout(() => {
                setSuccessMessage(null);
            }, SHARED_CONSTANTS.SUCCESS_SNACKBAR_CLEAR_TIME);
        },
    });
}
